export default Object.freeze({
  Email: 1,
  CorreoInterno: 2,
  Reporte: 3,
  FacturacionEnLineaSAEE: 4,
  FacturacionEnLineaRP: 5,
});
